import { css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';

@customElement('cds-menu-item')
export class MenuItemElement extends LitElement {
  static styles = css`
    :host {
      align-items: flex-start;
      align-self: stretch;
      background: var(--token-component-dropdown-background-default, light-dark(#ffffff, #343438));
      cursor: pointer;
      display: flex;
      gap: var(--token-global-spacing-s8, 8px);
      padding: var(--token-global-spacing-s8, 8px) var(--token-global-spacing-s12, 12px);
      white-space: nowrap;
    }

    :host(:hover) {
      color: var(--token-component-overflow-menu-button-hover-icon, light-dark(#009cde, #96cff0));
    }
  `;

  @property({ type: Boolean, reflect: true })
  disabled = false;

  @property({ type: String, reflect: true })
  role = 'menuitem';

  @property({ type: String, reflect: true })
  tabindex = '0';

  @property({ type: String, reflect: true })
  value = '';

  constructor() {
    super();
    this.addEventListener('click', this.handleClick);
    this.addEventListener('keydown', this.handleKeyDown);
  }

  render() {
    return html`<slot></slot>`;
  }

  private handleClick(): void {
    this.dispatchEvent(
      new CustomEvent('select', {
        bubbles: true,
        composed: true,
        detail: this.value,
      }),
    );
  }

  private handleKeyDown(e: KeyboardEvent): void {
    if (e.key === 'Enter' || e.key === ' ') {
      this.handleClick();
    }
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'cds-menu-item': MenuItemElement;
  }
}
